import { useState, useEffect } from "react";
import Modal from "react-modal";
import OrdenForm from "./OrdenForm";
import Paginador from "./Paginador";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

const BandejaOrdenes = ({
  ordenes,
  onRowClick,
  guardarOrden,
  selectedOrdenId,
  orden,
  proveedores,
}) => {
  const [filteredOrdenes, setFilteredOrdenes] = useState(ordenes);
  const { formatDate } = useFunctionsPrevia();
  const [showModal, setShowModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showBulkActionsOptions, setShowBulkActionsOptions] = useState(false);
  const [selectedOrdenes, setSelectedOrdenes] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(filteredOrdenes.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const paginatedOrdenes = filteredOrdenes.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const results = [];

    ordenes.forEach((orden) => {
      let matchScore = 0;

      // 1) Importe formateado (mayor peso, +4)
      const formattedImporte = parseFloat(orden?.total || 0)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (formattedImporte.includes(searchTerm)) {
        matchScore += 4;
      }
      if ((orden.nombreProveedor || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if ((orden.comprador || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if ((orden.condicion || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if ((orden.cotizacion || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if ((orden.divisa || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if ((orden.estado || "").toLowerCase().includes(searchTerm)) {
        matchScore += 2;
      }
      if ((orden.incoterm || "").toLowerCase().includes(searchTerm)) {
        matchScore += 2;
      }
      if ((orden.notas || "").toLowerCase().includes(searchTerm)) {
        matchScore += 2;
      }
      if ((orden.referencia || "").toLowerCase().includes(searchTerm)) {
        matchScore += 2;
      }
      if ((orden.terminos || "").toLowerCase().includes(searchTerm)) {
        matchScore += 2;
      }

      let numeroStr = (orden.numeroOrden || "").toString().toLowerCase();
      if (numeroStr.includes(searchTerm)) {
        matchScore += 1;
      }

      if ((orden.fechaOrden || "").toLowerCase().includes(searchTerm)) {
        matchScore += 1;
      }
      if (orden.fechaOrden) {
        const dateFormats = formatDate(new Date(orden.fechaOrden), true);
        if (dateFormats.some((format) => format.includes(searchTerm))) {
          matchScore += 1;
        }
      }

      if (orden.fechaVencimiento) {
        const fecha = new Date(orden.fechaVencimiento);
        console.log(
          "Fecha vencimiento:",
          orden.fechaVencimiento,
          fecha.toString()
        );
        const dateFormats = formatDate(fecha, true);
        if (dateFormats.some((format) => format.includes(searchTerm))) {
          matchScore += 1;
        }
      }

      // Si el matchScore > 0, añadimos esta orden al array results
      if (matchScore > 0) {
        results.push({ ...orden, matchScore });
      }
    });

    // Ordenamos los resultados de mayor a menor matchScore
    results.sort((a, b) => b.matchScore - a.matchScore);

    setFilteredOrdenes(results);
    setCurrentPage(1);
  };

  const openFormulario = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const toggleBulkActionsOptions = () => {
    setShowBulkActionsOptions(!showBulkActionsOptions);
  };

  const handleSelectOrden = (ordenId) => {
    setSelectedOrdenes((prevSelected) =>
      prevSelected.includes(ordenId)
        ? prevSelected.filter((id) => id !== ordenId)
        : [...prevSelected, ordenId]
    );
  };

  // Checkbox genérico - seleccionar todos
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrdenes([]); // Deselecciona todo
    } else {
      setSelectedOrdenes(ordenes.map((orden) => orden.id)); // Selecciona todo
    }
    setSelectAll(!selectAll);
  };

  const showBulkActions = selectedOrdenes.length > 0;

  const exportarPDF = () => {
    console.log("Exportar como PDF");
  };

  const imprimir = () => {
    console.log("Imprimir orden");
  };

  const eliminar = () => {
    console.log("Eliminar orden");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".bulk-actions-right")) {
        setShowBulkActionsOptions(false);
      }
    };
    if (showBulkActionsOptions) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showBulkActionsOptions]);

  return (
    <div className="cotizaciones-bandeja">
      <div className="bandeja-search-form">
        <div className="bandeja-search-input-wrapper">
          <i className="bi bi-search"></i>
          <input
            type="text"
            className="bandeja-search-input"
            placeholder="Buscar..."
            onChange={handleSearch}
          />
        </div>
      </div>

      {showBulkActions && (
        <div className="bulk-actions">
          <div className="bulk-actions-left">
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
              style={{ marginTop: "0", alignSelf: "center" }}
            />
            <p>{selectedOrdenes.length} seleccionados</p>
          </div>

          <div className="bulk-actions-right-container">
            <button className="boton-accion">Marcar como enviado</button>
            <div
              className="bulk-actions-right"
              style={{ position: "relative" }}
            >
              <i
                className="bi bi-three-dots-vertical"
                onClick={toggleBulkActionsOptions}
                style={{ cursor: "pointer" }}
              ></i>
              {showBulkActionsOptions && (
                <div className="dropdown-options-bandeja">
                  <p onClick={exportarPDF}>
                    <i
                      style={{ fontSize: "14px" }}
                      className="bi bi-box-arrow-up-right"
                    ></i>
                    Exportar como PDF
                  </p>
                  <p onClick={imprimir}>
                    <i
                      style={{ fontSize: "14px" }}
                      className="bi bi-printer"
                    ></i>
                    Imprimir
                  </p>
                  <p onClick={eliminar}>
                    <i style={{ fontSize: "14px" }} className="bi bi-trash"></i>
                    Eliminar
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="encabezado">
        <div className="categoria-filtro" onClick={toggleDropdown}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ marginLeft: "10px" }}>Todas las ordenes</p>
            <i
              className="bi bi-chevron-down"
              style={{ color: "#007bff", fontWeight: "bold" }}
            ></i>
          </div>
          {showDropdown && (
            <div className="dropdown-menu">
              <p>
                <i className="bi bi-envelope-check"></i>Ordenes enviadas
              </p>
              <p>
                <i className="bi bi-clock"></i>Ordenes pendientes
              </p>
            </div>
          )}
        </div>
        <div className="acciones-encabezado" style={{ position: "relative" }}>
          <button className="boton-accion" onClick={openFormulario}>
            + Nuevo
          </button>
          <div style={{ position: "relative", display: "inline-block" }}>
            <i
              className="bi bi-three-dots-vertical"
              onClick={toggleOptions}
              style={{ cursor: "pointer" }}
            ></i>
            {showOptions && (
              <div className="dropdown-options-bandeja">
                <p onClick={() => console.log("Ordenar")}>
                  <i className="bi bi-arrow-down-up"></i>Ordenar
                </p>
                <p onClick={() => console.log("Importar")}>
                  <i className="bi bi-box-arrow-in-down"></i>Importar
                </p>
                <p onClick={() => console.log("Exportar")}>
                  <i className="bi bi-box-arrow-up"></i>Exportar
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* === Listado scrolleable === */}
      <div className="bandeja-content">
        {paginatedOrdenes.length > 0 ? (
          paginatedOrdenes.map((orden) => (
            <div
              key={orden.id}
              className={`mensaje-cotizacion ${
                selectedOrdenId === orden.id ? "mensaje-seleccionado" : ""
              }`}
              onClick={() => {
                onRowClick(orden.id);
              }}
              tabIndex="0"
            >
              <div className="info-container">
                <input
                  type="checkbox"
                  onChange={() => handleSelectOrden(orden.id)}
                  checked={selectedOrdenes.includes(orden.id)}
                />
                <div className="info-column">
                  <div className="cliente-importe">
                    <span className="cliente-nombre">
                      {orden.nombreProveedor}
                    </span>
                    <span className="importe">
                      {orden.divisa}{" "}
                      {parseFloat(orden?.total || 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                  <div className="fecha-referencia">
                    <p> {orden.numeroOrden.toString().padStart(4, "0")}</p>
                    <span className="punto">•</span>
                    <p>{formatDate(new Date(orden.fechaOrden))}</p>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <div
                      className={`status ${
                        orden.estado === "Pendiente"
                          ? "pendiente"
                          : orden.estado === "En Proceso"
                          ? "en-proceso"
                          : orden.estado === "Facturado"
                          ? "facturado"
                          : "pagada"
                      }`}
                    >
                      {orden.estado}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{ position: "relative", left: "5%", marginTop: "80px" }}>
            <p style={{ fontSize: "14px" }}>
              No existe ninguna orden que coincida con esta búsqueda.
            </p>
            <div className="sin-resultados-animation" style={{ left: "10%" }}>
              <img
                src="/img/noSearch.svg"
                alt="Sin resultados"
                className="sin-resultados-imagen"
              />
            </div>
          </div>
        )}
      </div>

      {/* === Footer sticky con el paginador === */}
      <div className="paginador-wrap">
        <div className="paginador">
          <div style={{ paddingLeft: "10px", width: "35%" }}>
            <Paginador
              totalItems={filteredOrdenes.length}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
        </div>
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel="Nueva Orden"
        style={{
          overlay: {
            zIndex: 1008,
          },
          content: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            paddingLeft: 0,
            padding: 0,
            fontFamily: "Inter, sans-serif",
            "::WebkitScrollbar": {
              width: "0px",
              background: "transparent",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          },
        }}
      >
        <button onClick={closeModal} className="cerrar-button">
          <i className="bi bi-x-lg"></i>
        </button>

        <OrdenForm
          proveedores={proveedores}
          guardarOrden={guardarOrden}
          orden={orden}
          closeModal={closeModal}
        />
      </Modal>
    </div>
  );
};

export default BandejaOrdenes;
